import { AppEnv } from '@aries/defi-toolkit/types';
import Big from 'big.js';
import { isEmpty } from 'lodash';

// To avoid Big.toString() get string such as 1e23
Big.PE = 50;

export const ARIES_TEST_PROGRAM_ADDRESS =
  '0xeef200f2a06957a1548685c0feec9f1a04db27598fadab7f6daf30428fd064d3';

export const ARIES_PROGRAM_ADDRESS =
  '0x9770fa9c725cbd97eb50b2be5f7416efdfd1f1554beb0750d4dae4c64e860da3';

export const ARIES_MAINNET_MERKLE_POOL_PROGRAM_ADDRESS =
  '0xb7584e04e781e4c9c370fd9538594f46cd80b553a2fba8da3981f13bec304949';

export const APTOS_REDEMPTION_ADDRESS =
  '0xd47ead75b923422f7967257259e7a298f029da9e5484dc7aa1a9efbd4c3ae648';

export const ARIES_BORROW_USDC_CLAIM_ADDRESS_MAINNET =
  '0xb7584e04e781e4c9c370fd9538594f46cd80b553a2fba8da3981f13bec304949';

export const ARIES_BORROW_APT_CLAIM_ADDRSS_MAINNET =
  '0x9770fa9c725cbd97eb50b2be5f7416efdfd1f1554beb0750d4dae4c64e860da3';

export const ARIES_API_ENDPOINT = 'https://api-v2.ariesmarkets.xyz';

export const APT_EMODE_ID_TESTNET = 'apt';

export const APT_EMODE_ID_MAINNET = 'Apt';

export const STABLE_COINS_EMODE_ID_MAINNET = 'Stable';

export type FarmingType = 'DepositFarming' | 'BorrowFarming';

const PYTH_USDT =
  '0x2b89b9dc8fdf9f34709a5b106b472f0f39bb6ca9ce04b0fd7f2e971688e2e53b';
const PYTH_USDC =
  '0xeaa020c61cc479712813461ce153894a96a6c00b21ed0cfc2798d1f9a9e9c94a';
const PYTH_BTC =
  '0xc9d8b075a5c69303365ae23633d4e085199bf5c520a3b90fed1322a0342ffc33';
const PYTH_SUSDE =
  '0xca3ba9a619a4b3755c10ac7d5e760275aa95e9823d38a84fedd416856cdba37c';
const PYTH_APT =
  '0x03ae4db29ed4ae33d323568895aa00337e658e348b37509f5372ae51f0af00d5';
const PYTH_WETH =
  '0xff61491a931112ddf1bd8147cd1b641375f79f5825126d665480874634fd0ace';
const PYTH_CAKE =
  '0x2356af9529a1064d41e32d617e2ce1dca5733afa901daba9e2b68dee5d53ecf9';
const PYTH_USDY =
  '0xe393449f6aff8a4b6d3e1165a7c9ebec103685f3b41e60db4277b5b6d10e7326';
const PYTH_SOL =
  '0xef0d8b6fda2ceba41da15d4095d1da392a0d2f8ed0c6c7bc0f4cfac8c280b56d';

type ReserveInitConfig = {
  coinAddress: string;
  coinGeckoKey: string;
  farmTypes: FarmingType[];
  pythPriceId?: string;
  emodeIds?: string[];
  unwrappedFaAddress?: string;
};

// [${coinAddress}, ${coinGeckoKey}]
export const TESTNET_USDT_WCOIN =
  '0xeef200f2a06957a1548685c0feec9f1a04db27598fadab7f6daf30428fd064d3::fa_to_coin_wrapper::WrappedUSDT';

const TEST_USDT_FA =
  '0x998c1b8d58f71221ca9339ebceb20a1304c251c62a66952cdbe44383d164957d';
const RESERVES_TO_INIT_TESTNET_MAIN_POOL: ReserveInitConfig[] = [
  {
    coinAddress: '0x1::aptos_coin::AptosCoin',
    coinGeckoKey: 'aptos',
    farmTypes: ['DepositFarming', 'BorrowFarming'],
    emodeIds: [APT_EMODE_ID_TESTNET],
  },
  {
    coinAddress:
      '0x498d8926f16eb9ca90cab1b3a26aa6f97a080b3fcbe6e83ae150b7243a00fb68::devnet_coins::DevnetBTC',
    coinGeckoKey: 'bitcoin',
    farmTypes: ['DepositFarming', 'BorrowFarming'],
    pythPriceId:
      '0xf9c0172ba10dfa4d19088d94f5bf61d3b54d5bd7483a322a982e1373ee8ea31b',
  },
  {
    coinAddress:
      '0x498d8926f16eb9ca90cab1b3a26aa6f97a080b3fcbe6e83ae150b7243a00fb68::devnet_coins::DevnetUSDC',
    coinGeckoKey: 'usd-coin',
    farmTypes: ['DepositFarming', 'BorrowFarming'],
    pythPriceId:
      '0x41f3625971ca2ed2263e78573fe5ce23e13d2558ed3f2e47ab0f84fb9e7ae722',
    emodeIds: [APT_EMODE_ID_TESTNET],
  },
  {
    coinAddress: TESTNET_USDT_WCOIN,
    coinGeckoKey: 'tether',
    farmTypes: ['DepositFarming', 'BorrowFarming'],
    pythPriceId:
      '0x41f3625971ca2ed2263e78573fe5ce23e13d2558ed3f2e47ab0f84fb9e7ae722',
    unwrappedFaAddress: TEST_USDT_FA,
  },
];

const RESERVES_BY_MARKET_ID_TESTNET: Record<string, ReserveInitConfig[]> =
  {
    [ARIES_TEST_PROGRAM_ADDRESS]: RESERVES_TO_INIT_TESTNET_MAIN_POOL,
  };

export const APTOS_COIN_ADDRESS = '0x1::aptos_coin::AptosCoin';

export const MAINNET_USDT_WCOIN =
  '0x9770fa9c725cbd97eb50b2be5f7416efdfd1f1554beb0750d4dae4c64e860da3::fa_to_coin_wrapper::WrappedUSDT';
export const MAINNET_USDT_FA =
  '0x357b0b74bc833e95a115ad22604854d6b0fca151cecd94111770e5d6ffc9dc2b';
export const ZUSDT_ADDRESS =
  '0xf22bede237a07e121b56d91a491eb7bcdfd1f5907926a9e58338f964a01b17fa::asset::USDT';

export const ZUSDC_ADDRESS =
  '0xf22bede237a07e121b56d91a491eb7bcdfd1f5907926a9e58338f964a01b17fa::asset::USDC';
export const MAINNET_USDC_FA =
  '0xbae207659db88bea0cbead6da0ed00aac12edcdda169e591cd41c94180b46f3b';
export const MAINNET_USDC_WCOIN =
  '0x9770fa9c725cbd97eb50b2be5f7416efdfd1f1554beb0750d4dae4c64e860da3::wrapped_coins::WrappedUSDC';

export const MAINNET_SUSDE_FA =
  '0xb30a694a344edee467d9f82330bbe7c3b89f440a1ecd2da1f3bca266560fce69';
export const MAINNET_SUSDE_WCOIN =
  '0x9770fa9c725cbd97eb50b2be5f7416efdfd1f1554beb0750d4dae4c64e860da3::wrapped_coins::WrappedSUSDe';

export const MAINNET_XBTC_FA =
  '0x81214a80d82035a190fcb76b6ff3c0145161c3a9f33d137f2bbaee4cfec8a387';
export const MAINNET_XBTC_WCOIN =
  '0x9770fa9c725cbd97eb50b2be5f7416efdfd1f1554beb0750d4dae4c64e860da3::wrapped_coins::WrappedXBTC';

export const MAINNET_WBTC_FA =
  '0x68844a0d7f2587e726ad0579f3d640865bb4162c08a4589eeda3f9689ec52a3d';
export const MAINNET_WBTC_WCOIN =
  '0x9770fa9c725cbd97eb50b2be5f7416efdfd1f1554beb0750d4dae4c64e860da3::wrapped_coins::WrappedWBTC';

export const MAINNET_ABTC_COIN =
  '0x4e1854f6d332c9525e258fb6e66f84b6af8aba687bbcb832a24768c4e175feec::abtc::ABTC';
export const MAINNET_ABTC_FA =
  '0xf599112bc3a5b6092469890d6a2f353f485a6193c9d36626b480704467d3f4c8';

const RESERVES_TO_INIT_MAINNET_MAIN_POOL: ReserveInitConfig[] = [
  {
    coinAddress: MAINNET_USDT_WCOIN,
    coinGeckoKey: 'tether',
    farmTypes: ['DepositFarming', 'BorrowFarming'],
    pythPriceId: PYTH_USDT,
    emodeIds: [STABLE_COINS_EMODE_ID_MAINNET],
    unwrappedFaAddress: MAINNET_USDT_FA,
  },
  {
    // LayerZero USDT (zUSDT) is deprecated and no longer part of any emode.
    coinAddress: ZUSDT_ADDRESS,
    coinGeckoKey: 'tether',
    farmTypes: ['DepositFarming', 'BorrowFarming'],
    pythPriceId: PYTH_USDT,
  },
  {
    coinAddress: MAINNET_USDC_WCOIN,
    coinGeckoKey: 'usd-coin',
    farmTypes: ['DepositFarming', 'BorrowFarming'],
    pythPriceId: PYTH_USDC,
    emodeIds: [STABLE_COINS_EMODE_ID_MAINNET],
    unwrappedFaAddress: MAINNET_USDC_FA,
  },
  {
    // LayerZero USDC (zUSDC) is deprecated and no longer part of any emode.
    coinAddress: ZUSDC_ADDRESS,
    coinGeckoKey: 'usd-coin',
    farmTypes: ['DepositFarming', 'BorrowFarming'],
    pythPriceId: PYTH_USDC,
  },
  {
    coinAddress: MAINNET_XBTC_WCOIN,
    coinGeckoKey: 'bitcoin',
    farmTypes: ['DepositFarming', 'BorrowFarming'],
    pythPriceId: PYTH_BTC,
    unwrappedFaAddress: MAINNET_XBTC_FA,
  },
  {
    coinAddress: MAINNET_WBTC_WCOIN,
    coinGeckoKey: 'bitcoin',
    farmTypes: ['DepositFarming', 'BorrowFarming'],
    pythPriceId: PYTH_BTC,
    unwrappedFaAddress: MAINNET_WBTC_FA,
  },
  {
    coinAddress: MAINNET_ABTC_COIN,
    coinGeckoKey: 'abtc',
    farmTypes: ['DepositFarming', 'BorrowFarming'],
    pythPriceId: PYTH_BTC,
  },
  {
    // sUSDe was removed from the Stable coins emode on-chain (verified via
    // reserve_emode view → empty), so it is no longer part of any emode.
    coinAddress: MAINNET_SUSDE_WCOIN,
    coinGeckoKey: 'ethena-staked-usde',
    farmTypes: ['DepositFarming', 'BorrowFarming'],
    pythPriceId: PYTH_SUSDE,
    unwrappedFaAddress: MAINNET_SUSDE_FA,
  },
  {
    coinAddress: APTOS_COIN_ADDRESS,
    coinGeckoKey: 'aptos',
    farmTypes: ['DepositFarming', 'BorrowFarming'],
    pythPriceId: PYTH_APT,
    emodeIds: [APT_EMODE_ID_MAINNET],
  },
  {
    coinAddress:
      '0xcc8a89c8dce9693d354449f1f73e60e14e347417854f029db5bc8e7454008abb::coin::T',
    coinGeckoKey: 'ether',
    farmTypes: [],
    pythPriceId: PYTH_WETH,
  },
  {
    coinAddress:
      '0xf22bede237a07e121b56d91a491eb7bcdfd1f5907926a9e58338f964a01b17fa::asset::WETH',
    coinGeckoKey: 'ether',
    farmTypes: [],
    pythPriceId: PYTH_WETH,
  },
  {
    coinAddress:
      '0x111ae3e5bc816a5e63c2da97d0aa3886519e0cd5e4b046659fa35796bd11542a::stapt_token::StakedApt',
    coinGeckoKey: 'amnis-aptos',
    farmTypes: [],
    emodeIds: [APT_EMODE_ID_MAINNET],
  },
  {
    coinAddress:
      '0xf22bede237a07e121b56d91a491eb7bcdfd1f5907926a9e58338f964a01b17fa::asset::WBTC',
    coinGeckoKey: 'bitcoin',
    farmTypes: ['DepositFarming'],
    pythPriceId: PYTH_BTC,
  },
  {
    coinAddress:
      '0x159df6b7689437016108a019fd5bef736bac692b6d4a1f10c941f6fbb9a74ca6::oft::CakeOFT',
    coinGeckoKey: 'pancakeswap-token',
    farmTypes: [],
    pythPriceId: PYTH_CAKE,
  },
  {
    coinAddress:
      '0x111ae3e5bc816a5e63c2da97d0aa3886519e0cd5e4b046659fa35796bd11542a::amapt_token::AmnisApt',
    coinGeckoKey: 'amnis-aptos',
    farmTypes: [],
    pythPriceId: PYTH_APT,
    emodeIds: [APT_EMODE_ID_MAINNET],
  },
  {
    coinAddress:
      '0xcfea864b32833f157f042618bd845145256b1bf4c0da34a7013b76e42daa53cc::usdy::USDY',
    coinGeckoKey: 'ondo-us-dollar-yield',
    farmTypes: [],
    pythPriceId: PYTH_USDY,
  },
  {
    coinAddress:
      '0x5e156f1207d0ebfa19a9eeff00d62a282278fb8719f4fab3a586a0a2c0fffbea::coin::T',
    coinGeckoKey: 'usd-coin',
    farmTypes: [],
    pythPriceId: PYTH_USDC,
  },
  {
    coinAddress:
      '0xdd89c0e695df0692205912fb69fc290418bed0dbe6e4573d744a6d5e6bab6c13::coin::T',
    coinGeckoKey: 'solana',
    farmTypes: [],
    pythPriceId: PYTH_SOL,
  },
  {
    coinAddress:
      '0x84d7aeef42d38a5ffc3ccef853e1b82e4958659d16a7de736a29c55fbbeb0114::staked_aptos_coin::StakedAptosCoin',
    coinGeckoKey: 'tortuga-staked-aptos',
    farmTypes: [],
  },
  // '0xae478ff7d83ed072dbc5e264250e67ef58f57c99d89b447efd8a0a2e8b2be76e::coin::T', // BTC
  // '0xcc8a89c8dce9693d354449f1f73e60e14e347417854f029db5bc8e7454008abb::coin::T', // ETH
];

export const MAINNET_MERKLE_POOL_USDC_WCOIN =
  '0xb7584e04e781e4c9c370fd9538594f46cd80b553a2fba8da3981f13bec304949::wrapped_coins::WrappedUSDC';
export const MAINNET_MERKLE_LP =
  '0x5ae6789dd2fec1a9ec9cccfb3acaf12e93d432f0a3a42c92fe1a9d490b7bbc06::house_lp::MKLP<0x5ae6789dd2fec1a9ec9cccfb3acaf12e93d432f0a3a42c92fe1a9d490b7bbc06::fa_box::W_USDC>';
const RESERVES_TO_INIT_MAINNET_MERKLE_POOL: ReserveInitConfig[] = [
  {
    coinAddress: MAINNET_MERKLE_POOL_USDC_WCOIN,
    coinGeckoKey: 'usd-coin',
    farmTypes: ['DepositFarming', 'BorrowFarming'],
    pythPriceId: PYTH_USDC,
    unwrappedFaAddress: MAINNET_USDC_FA,
  },
  {
    coinAddress: MAINNET_MERKLE_LP,
    coinGeckoKey: 'usd-coin',
    farmTypes: ['DepositFarming', 'BorrowFarming'],
  },
];

const RESERVES_BY_MARKET_ID_MARINNET: Record<string, ReserveInitConfig[]> =
  {
    [ARIES_PROGRAM_ADDRESS]: RESERVES_TO_INIT_MAINNET_MAIN_POOL,
    [ARIES_MAINNET_MERKLE_POOL_PROGRAM_ADDRESS]:
      RESERVES_TO_INIT_MAINNET_MERKLE_POOL,
  };

export const getReserveConfig = (env: AppEnv, marketId: string) => {
  let reserves: ReserveInitConfig[] = [];
  if (env.isMainnet) {
    reserves = RESERVES_BY_MARKET_ID_MARINNET[marketId];
  }
  if (env.isTestnet) {
    reserves = RESERVES_BY_MARKET_ID_TESTNET[marketId];
  }
  if (!reserves || isEmpty(reserves)) {
    throw Error(
      `reserves not configured under ${JSON.stringify(
        env,
      )} marketId: ${marketId}`,
    );
  }

  return reserves;
};

const V2_ASSET_TYPE_TO_V1_TESTNET: Record<string, string[]> = {
  '0x000000000000000000000000000000000000000000000000000000000000000a': [
    APTOS_COIN_ADDRESS,
  ],
  [TEST_USDT_FA]: [TESTNET_USDT_WCOIN],
};

const V2_ASSET_TYPE_TO_V1_MAINNET: Record<string, string[]> = {
  '0x000000000000000000000000000000000000000000000000000000000000000a': [
    APTOS_COIN_ADDRESS,
  ],
  [MAINNET_USDT_FA]: [MAINNET_USDT_WCOIN],
  [MAINNET_USDC_FA]: [MAINNET_USDC_WCOIN, MAINNET_MERKLE_POOL_USDC_WCOIN],
  [MAINNET_SUSDE_FA]: [MAINNET_SUSDE_WCOIN],
  [MAINNET_XBTC_FA]: [MAINNET_XBTC_WCOIN],
  [MAINNET_WBTC_FA]: [MAINNET_WBTC_WCOIN],
  '0x2b3be0a97a73c87ff62cbdd36837a9fb5bbd1d7f06a73b7ed62ec15c5326c1b8': [
    ZUSDC_ADDRESS,
  ],
  '0x149125399662d1403e9e155cec665d68fc839e0100e9f3d0a4a1ad31f93b739e': [
    MAINNET_MERKLE_LP,
  ],
  [MAINNET_ABTC_FA]: [MAINNET_ABTC_COIN],
};

export const getV2AssetTypeToV1Map = (
  env: AppEnv,
): Record<string, string[] | undefined> => {
  if (env.isMainnet) {
    return V2_ASSET_TYPE_TO_V1_MAINNET;
  }
  if (env.isTestnet) {
    return V2_ASSET_TYPE_TO_V1_TESTNET;
  }
  throw Error(`reserves not configured under ${env}`);
};
